module.exports = __webpack_public_path__ + "img/tail20.5dfa6889.png";